










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import CompanyActionRecommendTable from '@/components/settings/company_action_recommend/Table.vue';

@Component({
  components: {
    Header,
    CompanyActionRecommendTable,
    Footer,
  },
})
export default class Company extends Vue {}
